export default __webpack_public_path__ + "static/media/bird_brains.01e0e608.png";